import { render, staticRenderFns } from "./EditPriceStatus.vue?vue&type=template&id=00b1493e&scoped=true"
import script from "./EditPriceStatus.vue?vue&type=script&lang=js"
export * from "./EditPriceStatus.vue?vue&type=script&lang=js"
import style0 from "./EditPriceStatus.vue?vue&type=style&index=0&id=00b1493e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1493e",
  null
  
)

export default component.exports